import { type FC, type ReactNode } from 'react';
interface RightSidebarLayoutProps {
  userProfile: ReactNode;
  loginButton: ReactNode;
  closeButton: ReactNode;
  calendarButton: ReactNode;
  emailSubcription: ReactNode;
}
export const RightSidebarMobileLayout: FC<RightSidebarLayoutProps> = ({
  userProfile,
  loginButton,
  closeButton,
  calendarButton,
  emailSubcription,
}) => {
  return (
    <div className="bg-back600 no-scrollbar overflow-auto px-5 pb-[90px]">
      <div className="border-b-back300 bg-back600 relative sticky top-0 flex h-[60px] items-center justify-between border-0 border-b border-solid">
        <h5 className="text-text300 mb-0 text-sm font-semibold">
          Profile & Events
        </h5>
        {closeButton}
      </div>
      {userProfile}
      {loginButton && <div className="relative z-10 pt-5">{loginButton}</div>}
      {calendarButton}
      {emailSubcription}
    </div>
  );
};

interface RightSidebarXLLayoutProps {
  userProfile: ReactNode;
  loginButton: ReactNode;
  header: ReactNode;
  calendarButton: ReactNode;
  emailSubcription: ReactNode;
}
export const RightSidebarXLLayout: FC<RightSidebarXLLayoutProps> = ({
  userProfile,
  loginButton,
  header,
  calendarButton,
  emailSubcription,
}) => {
  return (
    <div className="bg-back600 no-scrollbar overflow-auto px-5 pb-[90px]">
      <div className="border-bgColor15 relative z-10 -mx-5 flex h-[70px] items-center border-b px-5">
        {header}
      </div>
      <div className="pt-[30px]">
        {userProfile}
        {loginButton && <div className="pt-5">{loginButton}</div>}
        {calendarButton}
        {emailSubcription}
      </div>
    </div>
  );
};
